<script>
	import { createEventDispatcher } from 'svelte';
	import { Button } from 'flowbite-svelte';
	import icon from './images/logo.svg';

	const dispatch = createEventDispatcher();
</script>

<Button
	on:click={() => dispatch('click')}
	class="!p-0 w-20 h-20 bg-gradient-to-tl from-blue-950 to-blue-900 rounded-full focus:ring-0 flex items-center justify-center relative z-0"
>
	<img src={icon} alt="" width="57" class="relative z-[1] object-cover" />
	<div class="w-[7px] h-[7px] left-[62px] top-[25px] absolute bg-lime-200 rounded-full z-[2]" />
</Button>
